import React from 'react';
import { FormControl, FormGroup, Button, Row, Col } from 'react-bootstrap';
import Api from '../../api/api';
import ValidatedField from '../Validation/ValidatedField';
import Validator from '../Validation/Validator';

class RecoveryEmail extends React.Component {
  state = {
    email: '',
    errors: [],
  };

  componentDidMount() {
    this.email.focus();
  }

  validator = new Validator({
    email: [Validator.required, Validator.email],
  });

  handleInputChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      email: event.target.value,
    });
  };

  checkEmail = () => Api.users.checkEmail(this.state.email);

  handleSubmit = e => {
    e.preventDefault();

    this.setState({ errors: [] }, async () => {
      const errors = this.validator.validate(this.state);

      if (errors.length) {
        this.setState({ errors });
      } else {
        await Api.users.checkEmail(this.state.email).then(
          response =>
            !response &&
            this.setState({
              errors: [
                ...this.state.errors,
                { field: 'email', message: 'This email address is not associated with an active user account' },
              ],
            }),
        );

        Api.users
          .getResetPasswordEmail({ user: { email: this.state.email } })
          .then(() => {
            this.props.setMessage(
              'We have sent an email to your email address.  Please click the link in the email to reset your password.',
            );
            this.props.handleModalClose();
          })
          .catch(error => {
            const {
              response: { data },
            } = error;
            let message = 'Did you enter the correct email?';

            if (data && data.email.length) {
              message = data.email[0];
            }

            errors.push({ field: 'email', message });

            this.setState({ errors });
          });
      }
    });
  };

  render() {
    return (
      <div className="main-fullheight">
        <div className="fullheight">
          <Row className="show-grid">
            <form onSubmit={this.handleSubmit}>
              <Col md={12} className="show-grid-pass">
                <h2 className="heading hd-left forgot-pass">Forgot your password?</h2>
                <p className="description-form">Enter your email below and we'll send you a link to reset it</p>
                <Col md={12}>
                  <FormGroup>
                    <ValidatedField field="email" errors={this.state.errors}>
                      <FormControl
                        inputRef={ref => {
                          this.email = ref;
                        }}
                        type="text"
                        placeholder="Enter Email Address"
                        onChange={this.handleInputChange}
                        value={this.state.email}
                      />
                    </ValidatedField>
                  </FormGroup>
                </Col>
                <Col md={6} />
                <Col md={6}>
                  <div className="white-submit">
                    <Button type="submit" bsStyle="primary">
                      Ok
                    </Button>
                  </div>
                </Col>
              </Col>
            </form>
          </Row>
        </div>
      </div>
    );
  }
}

export default RecoveryEmail;



// WEBPACK FOOTER //
// ./src/components/Login/RecoveryEmail.js